import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { roleGuard } from './guards/role.guard';
import { propertyDetailResolver } from './resolvers/property-detail.resolver';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'catalog',
    loadComponent: () => import('./features/catalog/catalog.component').then(m => m.CatalogComponent)
  },
  {
    path: 'map-catalog',
    loadComponent: () => import('./features/map-catalog/map-catalog.component').then(m => m.MapCatalogComponent)
  },
  {
    path: 'property/:id',
    loadComponent: () => import('./features/property-detail/property-detail.component').then(m => m.PropertyDetailComponent),
    resolve: { property: propertyDetailResolver },
  },
  {
    path: 'user/:id',
    loadComponent: () => import('./features/user-public-profile/user-public-profile.component').then(m => m.UserPublicProfileComponent)
  },
  {
    path: 'login',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'register',
    loadComponent: () => import('./features/auth/register.component').then(m => m.RegisterComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./features/auth/forgot-password.component').then(m => m.ForgotPasswordComponent)
  },
  {
    path: 'profile',
    loadComponent: () => import('./features/profile/profile.component').then(m => m.ProfileComponent),
    canActivate: [authGuard]
  },
  {
    path: 'my-properties',
    loadComponent: () => import('./features/my-properties/my-properties.component').then(m => m.MyPropertiesComponent),
    canActivate: [authGuard]
  },
  {
    path: 'moderation',
    loadComponent: () => import('./features/moderation/moderation.component').then(m => m.ModerationComponent),
    canActivate: [roleGuard('moderator')]
  },
  {
    path: 'admin/analytics',
    loadComponent: () => import('./features/analytics-dashboard/analytics-dashboard.component').then(m => m.AnalyticsDashboardComponent),
    canActivate: [roleGuard('admin')]
  },
  {
    path: 'admin/portal',
    loadComponent: () => import('./features/portal-admin/portal-admin.component').then(m => m.PortalAdminComponent),
    canActivate: [roleGuard('admin')]
  },
  {
    path: 'create-property',
    loadComponent: () => import('./features/create-property/create-property.component').then(m => m.CreatePropertyComponent),
    canActivate: [authGuard]
  },
  {
    path: 'edit-property/:id',
    loadComponent: () => import('./features/edit-property/edit-property.component').then(m => m.EditPropertyComponent),
    canActivate: [authGuard]
  },
  {
    path: 'favorites',
    loadComponent: () => import('./features/favorites/favorites-redirect.component').then(m => m.FavoritesRedirectComponent),
    canActivate: [authGuard]
  },
  {
    path: 'chat',
    loadComponent: () => import('./features/chat/chat.component').then(m => m.ChatComponent),
    canActivate: [authGuard]
  },
  {
    path: 'notifications',
    loadComponent: () => import('./features/notifications/notifications.component').then(m => m.NotificationsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'terms',
    loadComponent: () => import('./features/content/static-page.component').then(m => m.StaticPageComponent),
    data: { file: 'legal/terms.html', title: 'Условия использования', browserTitle: 'Недвижимость для людей и ИИ агентов. Условия использования' }
  },
  {
    path: 'privacy',
    loadComponent: () => import('./features/content/static-page.component').then(m => m.StaticPageComponent),
    data: { file: 'legal/privacy.html', title: 'Политика конфиденциальности', browserTitle: 'Недвижимость для людей и ИИ агентов. Политика конфиденциальности' }
  },
  {
    path: 'about',
    loadComponent: () => import('./features/content/static-page.component').then(m => m.StaticPageComponent),
    data: { file: 'about.html', title: 'О нас', browserTitle: 'Недвижимость для людей и ИИ агентов. О нас' }
  },
  {
    path: 'approach',
    loadComponent: () => import('./features/content/static-page.component').then(m => m.StaticPageComponent),
    data: { file: 'approach.html', title: 'Мы подбираем недвижимость под жизнь, а не только под фильтры', browserTitle: 'Недвижимость для людей и ИИ агентов. Наш подход' }
  },
  {
    path: 'contacts',
    loadComponent: () => import('./features/content/contacts-page.component').then(m => m.ContactsPageComponent)
  },
  {
    path: '**',
    loadComponent: () => import('./shared/not-found.component').then(m => m.NotFoundComponent)
  }
];
